<div [formGroup]="dateRangeForm">
  <mat-select formControlName="rangeSelect" placeholder="Date Range">
    <mat-option *ngFor="let option of options" [value]="option.value">
      {{ option.label }}
    </mat-option>
  </mat-select>
  <span formGroupName="range">
    <mat-form-field>
      <input
        matInput
        formControlName="startDate"
        [matDatepicker]="startPicker"
        placeholder="Start date"
      />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        formControlName="endDate"
        [matDatepicker]="endPicker"
        placeholder="End date"
      />
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </span>
</div>
